import React from 'react';
import NumberInput, { Props } from '.';

export default function NumberInputWithUpdateOnBlur(props: Props) {
  return (
    <NumberInput
      {...props}
      onChange={() => {}}
      onBlur={(value?: number) => {
        if (value !== props.value && value !== undefined) {
          props.onChange(value);
        }
      }}
    />
  );
}
